import { formatName } from "@api";
import type { IContact } from "@bbj-types/contact";
import { formatPhoneNumber } from "@root/utils/phoneLib";

export const contactInfo = (contact: IContact): string => {
  if (contact.firstName || contact.lastName) {
    return formatName(contact);
  }
  if (contact.email) {
    return contact.email;
  }
  if (contact.phone) {
    return formatPhoneNumber(contact.phone);
  }
  return "";
};
